/**
 =========================================================
 * Material Dashboard 2 React - v2.2.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2023 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import * as React from 'react';

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "@mui/material/Table";
import DataTable from "../../examples/Tables/DataTable";
import data from "../dashboard/components/Projects/data";
import useApi from "../../components/Utils/api";
import MDInput from "../../components/MDInput";
import toast from "react-hot-toast";
import subDays from "date-fns/subDays";
import startOfMonth from "date-fns/startOfMonth";
import addMonths from "date-fns/addMonths";
import endOfMonth from "date-fns/endOfMonth";
import { useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useEffect } from "react";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import MerchantOfficeDetails from "./tabs/merchantOffficeDetails";
import MerchantBankDetails from "./tabs/merchantBankDetails";
import MerchantOtherDetails from "./tabs/merchantOtherDetails";
import MerchantEstablishmentDeclaration from "./tabs/merchantEstablishmentDeclaration";
import MerchantTerminals from "./tabs/terminals";
import MerchantUsers from "./tabs/users";
import MDAvatar from "../../components/MDAvatar";
import Icon from "@mui/material/Icon";
import MDConfirmAlert from "../../components/MDConfirmAlert";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { merchantSchema } from "../../models/merchantModel";
import CustomTabPanel from '../../components/CustomTabPanel';
import PermissionControl from "../../components/Utils/PermissionControl";
import MerchantDeviceSelection from "./tabs/merchantDeviceSelection";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
function Single() {
  const {state} = useLocation();
  const [merchant, setMerchant] = React.useState({});
  const [merchantInner, setMerchantInner] = React.useState({});
  const [selectedDevices, setSelectedDevices] = React.useState([]);
  const [merchantbk, setMerchantbk] = React.useState({});
  const [value, setValue] = React.useState(0);
  const [innervalue, setInnerValue] = React.useState(0);
  const [editMode, setEditMode] = React.useState(false);
  const { register, handleSubmit, reset, formState: { errors }, trigger, watch, control } = useForm({
    mode: "onChange",
    resolver: yupResolver(merchantSchema),
    defaultValues: merchantInner
  });
  const [requiredInfo, setRequiredInfo] = React.useState({
    mcclist : [],
    referenceCompany : [],
    microAtm : []
  })
  const handleDeviceSelectionChange = (newSelection) => {
    setSelectedDevices(newSelection);
  };
  const handleChange = (event, newValue) => {
    if (editMode === true && (JSON.stringify(merchant) !== JSON.stringify(merchantbk))) {
      toast.custom((t) => (
        <MDConfirmAlert
          text="You have some unsaved changes. Do you want to save the changes?"
          toast={toast}
          t={t}
          confirmFunction={() => {
            toast.dismiss(t.id);
            updateMerchant();
            setValue(newValue);
            if(state != null && state.companyId){
              getSingleMerchant(state.companyId);
            }
          }}
          cancelFunction={() => {
            toast.dismiss(t.id);
            if(state != null && state.companyId){
              getSingleMerchant(state.companyId);
            }
            setEditMode(false);
            setValue(newValue);
          }}
        />
      ), {
        duration: Infinity,
      });
      return;
    }
    setValue(newValue);
    setEditMode(false);
  };
  function convertNullToEmpty(obj) {
    for (let key in obj) {
      if (obj[key] === null || obj[key] === '') {
        obj[key] = '';
      } else if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
        // Recursive call if the value is another object
        convertNullToEmpty(obj[key]);
      }
    }
    return obj;
  }

  const handleInnerChange = (event, newValue) => {
    setInnerValue(newValue);
  };
  const api = useApi();
  const getSingleMerchant = (id) => {
    api.get("adminPortal/merchant/"+id)
      .then((response) => {
        if(response.data.responseCode === 200) {
          let result = response.data.data;
          convertNullToEmpty(result);
          setMerchant({ ...result , transferType: result?.transactionCode});
          setMerchantbk({ ...result , transferType: result?.transactionCode});
          // setRequiredInfo({
          //   cityList : result.cityList,
          //   referenceCompany : result.referenceCompany,
          //   microAtm : result.microAtm
          // });
          // result.merchant.mccCode = result.merchant.merchantCategoryCode.merchantCode;
          handleDeviceSelectionChange(result.deviceIds || []);
          reset({ ...result , transferType: result?.transactionCode});
        } else {
          toast.error(response.data.error);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          toast.error("You do not have permission to perform this action.");
          return;
        }
        console.log(error.response.data);
      })
  }
  useEffect(() => {
    api
      .get("mcc/all")
      .then((res) => {
        setRequiredInfo((prev) => ({
          ...prev,
          mcclist: res.data || [],
        }));
      })
      .catch(() => {
        setRequiredInfo((prev) => ({ ...prev, mcclist: [] }));
      });
  }, []);
  const formSubmit = () => {
    handleSubmit(updateMerchant)();
  }
  const updateMerchant = (data) => {
    data.transactionCode = data.transferType;
    

    data.deviceIds = selectedDevices,
    // console.log(data, "form submit")
    // let formData = {...data, merchantCategoryCode: {
    //     merchantCode: data.mccCode,
    //     merchantDescription: "",
    //     status: ""
    //   }}
    api.put("adminPortal/merchant/update/"+merchant.id, data)
      .then((response) => {
        if(response.data.responseCode === 200){
          setEditMode(false);
          toast.success("Merchant updated successfully");
          // window.location.reload();
        } else {
          toast.error(response?.data?.responseMessage ||"Merchant update failed");
        }
      })
      .catch((error)  => {
        toast.error("Merchant update failed");
        console.error(error);
      });
  }
  const cancelEditMode = () => {
    if(state != null && state.companyId){
      getSingleMerchant(state.companyId);
    }
    setEditMode(false);
  }
  useEffect(() => {
    if(state != null && state.id){
      getSingleMerchant(state.id);
    }
  }, [state]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          {/* <Grid item xs={12} md={4} lg={4}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                <Tab label="Basic Info" {...a11yProps(0)} />
                <Tab label="Terminals" {...a11yProps(1)} />
                <Tab label="Users" {...a11yProps(2)} />
              </Tabs>
            </Box>
          </Grid> */}
          <Grid item xs={12} md={12} lg={12}>
            {/* <CustomTabPanel value={value} index={0}> */}
              <Grid container justifyContent="flex-end">
                {editMode === false &&
                    <PermissionControl permission={{ restrict: true, module: "Merchants", subModule: "Update" }}>
                    <MDButton variant="outlined" color="info" onClick={() => setEditMode(true)} style={{marginBottom: "12px"}}>
                      <Icon fontSize="lg">mode-edit</Icon> Edit
                    </MDButton>
                    </PermissionControl>
                }
                {editMode === true && (
                  <>
                    <MDButton variant="outlined" color="info" onClick={() => cancelEditMode()} style={{marginRight: "24px", marginBottom: "12px"}}>
                      Cancel
                    </MDButton>
                    <MDButton variant="outlined" color="info" onClick={() => formSubmit()} style={{marginBottom: "12px"}}>
                      Save
                    </MDButton>
                  </>
                )}
              </Grid>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                  value={innervalue}
                  onChange={handleInnerChange}
                  aria-label="Basic info inner tabs"
                  scrollButtons
                  allowScrollButtonsMobile
                >
                  <Tab
                    sx={{
                      fontSize: {
                        xxl: '1rem',
                        lg: '0.9rem',
                        md: '0.9rem',
                        sm: '0.8rem',
                        xs: '0.6rem'
                      }
                    }}
                    label="MERCHANT OFFICE DETAILS"
                    {...a11yProps(0)} />
                  <Tab
                    sx={{
                      fontSize: {
                        xxl: '1rem',
                        lg: '0.9rem',
                        md: '0.9rem',
                        sm: '0.8rem',
                        xs: '0.6rem'
                      }
                    }}
                    label="MERCHANT BANK DETAILS" {...a11yProps(1)} />
                  <Tab
                    sx={{
                      fontSize: {
                        xxl: '1rem',
                        lg: '0.9rem',
                        md: '0.9rem',
                        sm: '0.8rem',
                        xs: '0.6rem'
                      }
                    }}
                    label="Devices" {...a11yProps(2)} />
                 
                </Tabs>
              </Box>
              <Grid item xs={12} md={12} lg={12}>
                <FormProvider {...{ register, handleSubmit, reset, formState: { errors }, trigger, watch, requiredInfo, control }}>
                  <CustomTabPanel value={innervalue} index={0} style={{backgroundColor: 'white'}}>
                    <MerchantOfficeDetails 
                      merchant={merchant} 
                      editmode={editMode} 
                      setMerchant={setMerchant} 
                      type="update" 
                      mccList={requiredInfo?.mcclist}
                    />
                  </CustomTabPanel>
                  <CustomTabPanel value={innervalue} index={1} style={{backgroundColor: 'white'}}>
                    <MerchantBankDetails merchant={merchant} editmode={editMode} setMerchant={setMerchant} />
                  </CustomTabPanel>
                  <CustomTabPanel value={innervalue} index={2} style={{backgroundColor: 'white'}}>
                    <MerchantDeviceSelection
                      merchant={merchant}
                      selectedDevices={selectedDevices}
                      onDeviceSelectionChange={handleDeviceSelectionChange}
                      editMode={editMode}
                    />
                  </CustomTabPanel>
                  {/* <CustomTabPanel value={innervalue} index={3} style={{backgroundColor: 'white'}}>
                    <MerchantEstablishmentDeclaration merchant={merchant} editmode={editMode} setMerchant={setMerchant} />
                  </CustomTabPanel> */}
                </FormProvider>
              </Grid>
            {/* </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <MerchantTerminals merchant={merchant} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <MerchantUsers merchant={merchant} />
            </CustomTabPanel> */}
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Single;
